import store from '@/store';
/**
 * 设备类型判断工具类
 * 全局可复用，适用于上传组件及其他需要端兼容的场景
 */
export const deviceUtils = {
    /**
     * 判断是否为桌面端（Web/PC）
     * 排除平板、移动设备的桌面模式，兼容 Windows/Mac 主流桌面系统
     * @returns boolean
     */
    isDesktop() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobile = /mobile|android|ios|iphone|ipad|ipod|windows phone|blackberry|harmony/.test(userAgent);
        const isTablet = /ipad|tablet|nexus 7|galaxy tab/.test(userAgent) || deviceUtils.isPad();
        const isDesktopScreen = window.innerWidth >= 1024 || navigator.platform.indexOf('Win') !== -1 || navigator.platform.indexOf('Mac') !== -1;
        return !store.state.isPad && !isMobile && !isTablet && isDesktopScreen;
    },
    /**
     * 判断是否为 iOS 设备（iPhone/iPad/iPod/Mac OS）
     * 排除安卓设备，兼容所有 iOS 内核设备
     * @returns boolean
     */
    isIOS() {
        const userAgent = navigator.userAgent;
        const isIpadOSDesktop = navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1;
        return (/iPhone|iPad|iPod/.test(userAgent) || isIpadOSDesktop) && !/Android/.test(userAgent);
    },
    /**
     * 判断是否为 Pad 设备（以 iPad 为主，兼容平板设备）
     * 区分平板和手机，解决 Pad 端上传兼容问题
     * @returns boolean
     */
    isPad() {
        const platform = navigator.platform || '';
        return platform.includes('Linux aarch64');
    },
    /**
     * 判断是否为指定安卓平板，用于软键盘视口适配
     * 目前仅通过 userAgent 中的 AINOTE-A2 标识识别，不参与 Linux aarch64 的底部安全区逻辑
     * @returns boolean
     */
    isAndroidTablet() {
        const userAgent = navigator.userAgent || '';
        return /AINOTE-A2/i.test(userAgent);
    },
    /**
     * 判断当前设备是否需要软键盘动态视口适配
     * 仅 Linux aarch64 和 AINOTE-A2 需要处理键盘聚焦高度
     * 注意：这个判断不参与 Linux aarch64 的底部安全区逻辑
     * @returns boolean
     */
    shouldAdaptSoftKeyboard() {
        return deviceUtils.isPad() || deviceUtils.isAndroidTablet();
    },
    /**
     * 判断是否为需要特殊底部安全区的 Linux aarch64 平板壳
     * @returns boolean
     */
    isLinuxAarch64() {
        return (navigator.platform || '').includes('Linux aarch64');
    },
    /**
     * 判断当前屏幕方向
     * 优先使用 screen.orientation，避免软键盘弹起导致 innerHeight 变小后误判横竖屏
     * @returns boolean
     */
    isPortraitMode() {
        var _a, _b, _c, _d;
        const orientationType = ((_b = (_a = window.screen) === null || _a === void 0 ? void 0 : _a.orientation) === null || _b === void 0 ? void 0 : _b.type) || '';
        if (orientationType.includes('portrait')) {
            return true;
        }
        if (orientationType.includes('landscape')) {
            return false;
        }
        if (((_c = window.screen) === null || _c === void 0 ? void 0 : _c.height) && ((_d = window.screen) === null || _d === void 0 ? void 0 : _d.width)) {
            return window.screen.height >= window.screen.width;
        }
        return window.innerHeight >= window.innerWidth;
    }
};
